import Skeleton from 'react-loading-skeleton';

import { Text } from '../../cdl/Text/Text';
import type { TextProps } from '../../cdl/Text/Text';
import { Characters } from '../../common/helpers/unicode.helper';
import { Box } from '../../common/ui/Box';

import { DemandVolume } from './DemandVolume';

interface DemandHistoricalVolumeProps {
    color?: TextProps['color'];
    historicalVolume?: number;
    isLoading: boolean;
}

export const DemandHistoricalVolume = ({
    color = 'foreground.subtle',
    historicalVolume,
    isLoading,
}: DemandHistoricalVolumeProps) => {
    if (isLoading) {
        return (
            <Box display="flex" justifyContent="flex-end">
                <Skeleton width={104} height={16} />
            </Box>
        );
    }

    if (historicalVolume === undefined) {
        return (
            <Text variant="body" color={color} textAlign="right">
                {Characters.EN_DASH}
            </Text>
        );
    }

    return (
        <Box display="flex" justifyContent="flex-end">
            <Text variant="body" color={color}>
                <DemandVolume volume={historicalVolume} />
            </Text>
        </Box>
    );
};
